import { render } from "./ShortcutPage.vue?vue&type=template&id=7d80a230&scoped=true"
import script from "./ShortcutPage.vue?vue&type=script&lang=js"
export * from "./ShortcutPage.vue?vue&type=script&lang=js"

import "./ShortcutPage.vue?vue&type=style&index=0&id=7d80a230&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d80a230"]])

export default __exports__